import { render, staticRenderFns } from "./PostingRail.vue?vue&type=template&id=b9c8fc50&scoped=true"
import script from "./PostingRail.vue?vue&type=script&lang=js"
export * from "./PostingRail.vue?vue&type=script&lang=js"
import style0 from "./PostingRail.vue?vue&type=style&index=0&id=b9c8fc50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c8fc50",
  null
  
)

export default component.exports